import React, { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../store/auth-context";
import Frame1 from "../../images/Frame1.svg";
import useInterceptedNavigate from "../../hooks/useInterceptedNavigate";
import { GET } from "../../service/CRUDService";
import EntityConstants from "../../configs/EntityConstants";
import SignInSideCurtains from "../../components/SignInSideCurtains/SignInSideCurtains";
import SignUpSideCurtains from "../../components/SignUpSideCurtains/SignUpSideCurtains";
import toast from "react-hot-toast";
import AppConstants from "../../configs/AppConstants";
import { useTranslation } from "react-i18next";

const Home = () => {
  const navigate = useInterceptedNavigate();
  const { t } = useTranslation();

  const [footerBgColor, setFooterBgColor] = useState("");
  const [footerLogo, setFooterLogo] = useState("");
  const [footerLogoText, setFooterLogoText] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [officeHours, setOfficeHours] = useState("");
  const [orgAddress, setOrgAddress] = useState("");
  const [products, setProducts] = useState([]);
  const [bannerFrame, setBannerFrame] = useState("");
  const authContext = useContext(AuthContext);
  const [triggerLoginModuleToggleValue, setTriggerLoginModuleToggleValue] =
    useState(false);
  const [signOrSignUp, setSignOrSignUp] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);
  const [authProviders, setAuthProviders] = useState([]);

  const isIIITB = AppConstants.TRUSTED_IIITB_HOSTS.includes(
    window.location.origin,
  );

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const iiitbFaqs = [
    {
      question: t("homeAuthPages:q1"),
      answer: t("homeAuthPages:a1"),
    },
    {
      question: t("homeAuthPages:q2"),
      answer: t("homeAuthPages:a2"),
    },
    {
      question: t("homeAuthPages:q3"),
      answer: t("homeAuthPages:a3"),
    },
    {
      question: t("homeAuthPages:q4"),
      answer: t("homeAuthPages:a4"),
    },
    {
      question: t("homeAuthPages:q5"),
      answer: t("homeAuthPages:a5"),
    },
    {
      question: t("homeAuthPages:q6"),
      answer: t("homeAuthPages:a6"),
    },
    {
      question: t("homeAuthPages:q7"),
      answer: t("homeAuthPages:a7"),
    },
  ];

  const defaultFaqs = [
    {
      question: t("homeAuthPages:q8"),
      answer: t("homeAuthPages:a8"),
    },
    {
      question: t("homeAuthPages:q9"),
      answer: t("homeAuthPages:a9"),
    },
    {
      question: t("homeAuthPages:q10"),
      answer: t("homeAuthPages:a10"),
    },
    {
      question: t("homeAuthPages:q11"),
      answer: t("homeAuthPages:a11"),
    },
    {
      question: t("homeAuthPages:q12"),
      answer: t("homeAuthPages:a12"),
    },
    {
      question: t("homeAuthPages:q13"),
      answer: t("homeAuthPages:a13"),
    },
    {
      question: t("homeAuthPages:q14"),
      answer: t("homeAuthPages:a14"),
    },
  ];

  const faqs = isIIITB ? iiitbFaqs : defaultFaqs;

  const TriggerLoginModuleBtnFromModule = () => {
    setTriggerLoginModuleToggleValue(false);
  };
  const TriggerLoginModuleBtn = () => {
    setTriggerLoginModuleToggleValue(true);
  };

  const chooseSignUp_SignIn = (bool) => {
    setSignOrSignUp(bool);
  };

  function closeModal() {
    TriggerLoginModuleBtnFromModule();
  }

  function toggleComponent() {
    chooseSignUp_SignIn(!signOrSignUp);
  }

  useEffect(() => {
    authContext.isLoggedIn && navigate("/verifier/validate");
  }, [authContext.isLoggedIn]);

  const slides = [{ img: Frame1 }];

  // Refs for custom navigation buttons
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const GET_PRODUCT_DETAILS = async () => {
    try {
      const response = await GET(EntityConstants.GET_ORGANISATION_DETAILS);
      const data = await response.json();

      if (response.ok) {
        setFooterLogo(data.footer_logo);
        setFooterLogoText(data?.footer_text);
        setContactEmail(data.contact_email);
        setContactNumber(data.contact_number);
        setOfficeHours(data.working_hours);
        setOrgAddress(data.address);
        setProducts(data?.products?.products ?? []);
        setBannerFrame(data.banner_image);
        setFooterBgColor(data.footer_background_color);
        setAuthProviders(data.auth_providers || []);
      } else {
        console.log("Error:", data);
      }
    } catch (error) {
      console.error("Assets fetch failed:", error);
      toast.error(t("homeAuthPages:failed_to_fetch"));
    }
  };

  useEffect(() => {
    GET_PRODUCT_DETAILS();
  }, []);

  return (
    <div className="flex flex-col min-h-screen z-0 justify-between w-full bg-cfSecondary relative">
      <div className="flex flex-col lg:flex-row w-full">
        {bannerFrame && (
          <div
            className={`flex items-start ${
              authProviders.signin.length > 0 ? "lg:w-[65%]" : "w-full"
            }`}
          >
            <img
              id="home-banner-sign-in-button"
              src={bannerFrame}
              onClick={() => {
                TriggerLoginModuleBtn();
                chooseSignUp_SignIn(true);
              }}
              alt="Credissuer's Verify"
            />
          </div>
        )}
        {bannerFrame && authProviders.signin.length > 0 && (
          <div className="flex w-full lg:w-[35%] justify-center h-full overflow-y-auto">
            {signOrSignUp ? (
              <div className="overflow-y-clip">
                <SignInSideCurtains
                  closeModal={closeModal}
                  toggleComponent={toggleComponent}
                />
              </div>
            ) : (
              <div className="flex justify-center w-full px-5">
                <SignUpSideCurtains
                  closeModal={closeModal}
                  toggleComponent={toggleComponent}
                />
              </div>
            )}
          </div>
        )}
      </div>

      <div className="w-full py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="w-full flex flex-col items-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-3">
              {t("homeAuthPages:faq_title")}
            </h1>
            <p className="text-gray-600 text-lg font-medium mb-8">
              {t("homeAuthPages:faq_subtitle")}
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border border-gray-50 rounded-xl shadow-md p-4 bg-cfSecondary"
              >
                <button
                  id={`home-faq-toggle-button-${index}`}
                  className="flex justify-between items-center w-full text-left py-4 focus:outline-none"
                  onClick={() => toggleFAQ(index)}
                >
                  <h2 className="text-lg font-semibold text-gray-900">
                    {faq.question}
                  </h2>
                  <svg
                    className={`w-5 h-5 text-gray-500 transform transition-transform duration-300 ${
                      activeIndex === index ? "rotate-180" : ""
                    }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                {activeIndex === index && (
                  <div className="mt-2 text-gray-600 pb-4 transition-all duration-300 ease-in-out">
                    <div className="border-t border-gray-200 my-2"></div>
                    <p className="pt-2">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Footer */}
      <div
        className="w-full mt-4 bg-cfPrimary text-white justify-center flex pb-4"
        style={{ backgroundColor: footerBgColor || "#45489e" }}
      >
        <div className="py-[3rem]">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-30 xl:gap-40 justify-evenly px-4">
            <div className="text-white text-sm w-full lg:w-[20%] mt-3 lg:mt-0 flex flex-col items-left">
              <img
                src={footerLogo}
                className="mb-2 w-auto h-auto max-w-[150px]"
                alt="Footer logo"
              />
              {footerLogoText?.length > 0 && (
                <div className="text-xs">{footerLogoText}</div>
              )}
            </div>

            {products?.length > 0 && (
              <div className="text-white mt-[0rem] lg:mt-[1.7rem]">
                <div className="font-bold text-xl mb-[0.5rem]">
                  {t("homeAuthPages:products")}
                </div>
                {products.map((product, index) => (
                  <div className="font-medium mb-[0.3rem]" key={index}>
                    <a
                      href={product.product_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="relative hover:text-cfTextHover no-underline text-decoration-none"
                    >
                      {product.product_name}
                    </a>
                  </div>
                ))}
              </div>
            )}

            <div className="mt-[0rem] lg:mt-[1.7rem]">
              {(contactEmail?.length > 0 || contactNumber?.length > 0) && (
                <>
                  <div className="font-bold text-lg">
                    {t("homeAuthPages:get_in_touch")}
                  </div>
                  {contactEmail && (
                    <div className="font-medium mt-[0.3rem]">
                      <a
                        href={`mailto:${contactEmail}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="relative hover:text-cfTextHover no-underline text-decoration-none"
                      >
                        {contactEmail}
                      </a>
                    </div>
                  )}
                  {contactNumber && (
                    <div className="font-medium mt-[0.3rem]">
                      <a
                        href={`tel:${contactNumber}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="relative hover:text-cfTextHover no-underline text-decoration-none"
                      >
                        {contactNumber}
                      </a>
                    </div>
                  )}
                </>
              )}

              {officeHours && (
                <>
                  <div className="font-bold text-lg mt-[0.8rem]">
                    {t("homeAuthPages:office_hours")}
                  </div>
                  <div className="font-medium mt-[0.3rem]">{officeHours}</div>
                </>
              )}
            </div>

            {orgAddress != null && orgAddress.length > 0 && (
              <div className="w-full lg:w-[20%] mt-[0rem] lg:mt-[1.7rem]">
                <div className="font-bold text-lg">
                  {t("homeAuthPages:address")}
                </div>
                <div className="flex">
                  {/* <img
                    src={Location}
                    height={30}
                    width={30}
                    className=""
                    alt=""
                  /> */}
                  <div className="font-medium mt-[0.3rem]">{orgAddress}</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
